import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
//import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
@Component({
    selector: 'app-cliente-operadores-ayuda-popup',
    templateUrl: './cliente-operadores-ayuda-popup.component.html',
    styleUrls: ['./cliente-operadores-ayuda-popup.component.css'],
    standalone: true,
    imports: [FormsModule, MatIconModule, CommonModule, NbCardModule, NbIconModule, DropdownModule, MatCardModule, MatFormFieldModule, MatInputModule, AngularSlickgridModule, NbTabsetModule, MatDatepickerModule, MatNativeDateModule, NbSelectModule, NbTreeGridModule, MultiSelectModule],
})
export class ClienteOperadoresAyudaPopupComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ClienteOperadoresAyudaPopupComponent>) { }

  ngOnInit(): void {
  }
  close(){
    this.dialogRef.close();
  }
}
